import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { useSpace } from '@/hooks/useSpace'
import type { RootState } from '@/utils/store/store'
import type { FilterContentSelection } from '@/ui/advancedAssistants/MMA/types/Filter'

/**
 * The lines of the saved line filter of the active assistant: they are shown first in the lines of a source.
 */
const useSelectedSourceLines = (): string[] => {
    const { getActiveAssistant } = useSpace()
    const assistantId = getActiveAssistant()?.config?.id

    const savedFilter = useSelector((state: RootState) =>
        assistantId ? state.application.savedFilters?.[assistantId] : undefined
    ) as FilterContentSelection | undefined

    return useMemo(() => savedFilter?.line?.map((line) => line.value) ?? [], [savedFilter])
}

export default useSelectedSourceLines
